import { Modal } from 'antd'
import PackageForm from '../../../../components/Purchasing/Packages/PackageForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import React from 'react'

function PackageModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
    isUpdatable,
    isLocked,
  } = props
  const isNew = modalType === 'new'
  console.log(props, isNew)
  return (
    <Modal
      visible={visible}
      title={'Package'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={true}
          submit={submit}
          remove={remove}
          isRemovable={!isLocked}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <PackageForm ref={formRef} {...props} />
    </Modal>
  )
}

PackageModal.propTypes = {}
PackageModal.defaultProps = {}

export default PackageModal
